var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 5,
    fill: "#2820DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.00159C17.9998 7.26702 17.8928 7.52149 17.7028 7.70906L12.5198 12.8295C12.3629 12.9845 12.2384 13.1684 12.1535 13.3709C12.0686 13.5734 12.0249 13.7904 12.0249 14.0095C12.0249 14.2287 12.0686 14.4457 12.1535 14.6482C12.2384 14.8506 12.3629 15.0346 12.5198 15.1896L17.696 20.3034C17.8806 20.4922 17.9827 20.7451 17.9804 21.0076C17.9781 21.2701 17.8715 21.5212 17.6837 21.7068C17.4958 21.8924 17.2416 21.9977 16.9759 22C16.7102 22.0022 16.4542 21.9013 16.2631 21.719L11.0869 16.6092C10.3909 15.9202 10 14.9866 10 14.0132C10 13.0398 10.3909 12.1062 11.0869 11.4173L16.2699 6.29345C16.4116 6.15335 16.5922 6.05793 16.7888 6.01926C16.9855 5.9806 17.1893 6.00042 17.3745 6.07623C17.5597 6.15204 17.718 6.28043 17.8294 6.44515C17.9407 6.60987 18.0001 6.80352 18 7.00159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagArrowLeft);
export default __webpack_public_path__ + "static/media/pagArrowLeft.0568238d8d18702878ca7160cce1d86a.svg";
export { ForwardRef as ReactComponent };